export enum JpkVatState {
    NotApplicable = 'NotApplicable',
    NotProcessed = 'NotProcessed',
    Processed = 'Processed',
}
